var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.state)?_c('v-combobox',_vm._b({attrs:{"outlined":"","persistent-hint":"","items":_vm.items},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'v-combobox',_vm.attrs,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }